module.exports = __webpack_public_path__ + "acfbb93cfb4c7e6119362ef851a0457e.jpg";